module.exports = __webpack_public_path__ + "static/media/zp.f1e54b73.png";